<template>
  <h1>Writing</h1>
</template>

<script lang="ts">
export default {

}
</script>

<style>

</style>